// extracted by mini-css-extract-plugin
export default {"DIDQuery":"DIDQuery_DIDQuery__X3QZz","DIDQuery--Buttons":"DIDQuery_DIDQuery--Buttons__yKPJi"};